// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2jTmA":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchSmartCrops", ()=>fetchSmartCrops);
parcelHelpers.export(exports, "getSmartCropUrl", ()=>getSmartCropUrl);
parcelHelpers.export(exports, "getDynamicMediaUrl", ()=>getDynamicMediaUrl);
parcelHelpers.export(exports, "getImageUrl", ()=>getImageUrl);
parcelHelpers.export(exports, "getAssetUrl", ()=>getAssetUrl);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const DM_PARAMS = {
    dpr: 'on,1',
    fmt: 'webp',
    qlt: '85'
};
/**
 * Normalize a Dynamic Media S7 URL — spaces in asset names become underscores in DM.
 */ const normalizeDmUrl = (url)=>{
    if (!url) return url;
    // Replace encoded spaces (%20) and literal spaces with underscores
    return url.replace(/%20/g, '_').replace(/ /g, '_');
};
const fetchSmartCrops = async (dmS7Url)=>{
    if (!(dmS7Url === null || dmS7Url === void 0 ? void 0 : dmS7Url.includes('scene7.com'))) return null;
    const url = normalizeDmUrl(dmS7Url);
    try {
        var _text_match, _json_set_relation, _json_set;
        const res = await fetch(`${url}?req=set,json`);
        const text = await res.text();
        const json = JSON.parse(((_text_match = text.match(RegExp("\\{.*\\}", "s"))) === null || _text_match === void 0 ? void 0 : _text_match[0]) || '{}');
        return ((_json_set = json.set) === null || _json_set === void 0 ? void 0 : (_json_set_relation = _json_set.relation) === null || _json_set_relation === void 0 ? void 0 : _json_set_relation.map((r)=>r.n.split(':')[1])) || [];
    } catch (e) {
        return null;
    }
};
const getSmartCropUrl = (dmS7Url, cropName, params = {})=>{
    if (!(dmS7Url === null || dmS7Url === void 0 ? void 0 : dmS7Url.includes('scene7.com'))) return null;
    const url = normalizeDmUrl(dmS7Url);
    const merged = (0, _objectSpread._)({}, DM_PARAMS, params);
    const query = Object.entries(merged).map(([k, v])=>`${k}=${v}`).join('&');
    return `${url}:${cropName}?${query}`;
};
const getDynamicMediaUrl = (imageObj, cropName = null, params = {})=>{
    const dmUrl = normalizeDmUrl(imageObj === null || imageObj === void 0 ? void 0 : imageObj._dmS7Url);
    if (!dmUrl) return (imageObj === null || imageObj === void 0 ? void 0 : imageObj._publishUrl) || (imageObj === null || imageObj === void 0 ? void 0 : imageObj._path) || null;
    if (cropName) return getSmartCropUrl(dmUrl, cropName, params);
    const merged = (0, _objectSpread._)({}, DM_PARAMS, params);
    const query = Object.entries(merged).map(([k, v])=>`${k}=${v}`).join('&');
    return `${dmUrl}?${query}`;
};
const getImageUrl = (imageObj, smartCrops = [], preferredCrop = null)=>{
    if (!imageObj) return null;
    // Try SmartCrop first (requires _dmS7Url)
    if (imageObj._dmS7Url && (smartCrops === null || smartCrops === void 0 ? void 0 : smartCrops.length)) {
        const fallback = getDynamicMediaUrl(imageObj, null);
        // Single preferred crop (e.g. avatar)
        if (preferredCrop && smartCrops.includes(preferredCrop)) return {
            src: getDynamicMediaUrl(imageObj, preferredCrop)
        };
        // Responsive sources for hero images
        const sources = [];
        if (smartCrops.includes('Small')) sources.push({
            media: '(max-width: 639px)',
            srcSet: getDynamicMediaUrl(imageObj, 'Small')
        });
        if (smartCrops.includes('Small')) sources.push({
            media: '(min-width: 640px) and (max-width: 1023px)',
            srcSet: getDynamicMediaUrl(imageObj, 'Small')
        });
        if (smartCrops.includes('Medium')) sources.push({
            media: '(min-width: 1024px)',
            srcSet: getDynamicMediaUrl(imageObj, 'Medium')
        });
        return {
            src: fallback,
            sources: sources.length ? sources : undefined
        };
    }
    // _dmS7Url without crops
    if (imageObj._dmS7Url) return {
        src: getDynamicMediaUrl(imageObj)
    };
    // _publishUrl is already absolute
    if (imageObj._publishUrl) return {
        src: imageObj._publishUrl
    };
    // _dynamicUrl is relative — prefix with AEM host
    if (imageObj._dynamicUrl) {
        const endpoint = "https://publish-p133965-e1614727.adobeaemcloud.com/graphql/execute.json/ewsr";
        return {
            src: `${new URL(endpoint).origin}${imageObj._dynamicUrl}`
        };
    }
    return null;
};
const getAssetUrl = (assetObj)=>{
    // If we have _publishUrl, use it directly
    if (assetObj === null || assetObj === void 0 ? void 0 : assetObj._publishUrl) return assetObj._publishUrl;
    // If we have _path, construct absolute URL using GraphQL endpoint host
    if (assetObj === null || assetObj === void 0 ? void 0 : assetObj._path) {
        const graphqlEndpoint = "https://publish-p133965-e1614727.adobeaemcloud.com/graphql/execute.json/ewsr";
        const baseUrl = new URL(graphqlEndpoint).origin;
        return `${baseUrl}${assetObj._path}`;
    }
    // Fallback to string if passed directly
    if (typeof assetObj === 'string') {
        // If already absolute, return as-is
        if (assetObj.startsWith('http://') || assetObj.startsWith('https://')) return assetObj;
        // Otherwise construct absolute URL
        const graphqlEndpoint = "https://publish-p133965-e1614727.adobeaemcloud.com/graphql/execute.json/ewsr";
        const baseUrl = new URL(graphqlEndpoint).origin;
        return `${baseUrl}${assetObj}`;
    }
    return null;
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2AB8s":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ErrorFallback);
var _react = require("react"); // eslint-disable-line no-unused-vars
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function ErrorFallback({ error: _error, resetErrorBoundary, variant = 'page', className = '' }) {
    if (variant === 'section') return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `flex items-center gap-3 p-4 rounded-lg border border-yellow-200 bg-yellow-50 ${className}`,
        role: "alert"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "alert-circle",
        size: 20,
        color: "#FFC107"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        weight: "Strong",
        className: "text-yellow-800"
    }, "Etwas ist schiefgelaufen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "xs",
        className: "text-yellow-700"
    }, "Dieser Bereich ist gerade nicht verf\xFCgbar.")), resetErrorBoundary && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "outline",
        size: "sm",
        onClick: resetErrorBoundary
    }, "Erneut versuchen"));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `flex flex-col items-center justify-center min-h-[50vh] px-4 text-center ${className}`,
        role: "alert"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "alert-circle",
        size: 48,
        color: "#DC3545"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h3",
        className: "mt-4 text-eggs-dark"
    }, "Etwas ist schiefgelaufen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "Base",
        className: "mt-2 text-gray-600 max-w-md"
    }, "Keine Sorge \u2013 versuch es einfach nochmal. Falls das Problem bestehen bleibt, lade die Seite neu."), resetErrorBoundary && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "brand",
        size: "md",
        onClick: resetErrorBoundary,
        className: "mt-6"
    }, "Erneut versuchen"));
}

},{"react":"lbBKc","./Text":"ilUQ0","./Button":"gqkVm","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gqkVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Button);
parcelHelpers.export(exports, "BrandButton", ()=>BrandButton);
parcelHelpers.export(exports, "PrimaryButton", ()=>PrimaryButton);
parcelHelpers.export(exports, "SecondaryButton", ()=>SecondaryButton);
parcelHelpers.export(exports, "OutlineButton", ()=>OutlineButton);
parcelHelpers.export(exports, "GhostButton", ()=>GhostButton);
parcelHelpers.export(exports, "InverseButton", ()=>InverseButton);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Button(_param) {
    var { variant = 'brand', size = 'lg', hasLeadingIcon = false, hasTrailingIcon = false, leadingIcon = 'arrow-left', trailingIcon = 'arrow-right', children, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "variant",
        "size",
        "hasLeadingIcon",
        "hasTrailingIcon",
        "leadingIcon",
        "trailingIcon",
        "children",
        "className"
    ]);
    // Brand buttons always show a leading arrow
    const showLeadingIcon = variant === 'brand' ? true : hasLeadingIcon;
    const resolvedLeadingIcon = variant === 'brand' && !hasLeadingIcon ? 'arrow-right' : leadingIcon;
    // Base classes for all buttons
    const baseClasses = [
        'inline-flex',
        'items-center',
        'justify-center',
        'font-burns',
        'font-medium',
        'min-h-[44px]',
        'transition-all',
        'duration-200',
        'ease-in-out',
        'rounded-full',
        'cursor-pointer',
        'whitespace-nowrap',
        'focus:outline-none',
        'focus:ring-2',
        'focus:ring-offset-2',
        'disabled:opacity-40',
        'disabled:cursor-not-allowed',
        'disabled:pointer-events-none',
        'active:scale-[0.98]'
    ].join(' ');
    // Variant-specific styles
    const variantClasses = {
        brand: [
            'bg-eggs-yellow',
            'text-eggs-dark',
            'border-0',
            'hover:bg-eggs-dark',
            'hover:text-eggs-yellow',
            'focus:ring-eggs-yellow'
        ].join(' '),
        primary: [
            'bg-eggs-dark',
            'text-white',
            'border-0',
            'hover:bg-eggs-dark-hover',
            'focus:ring-eggs-dark'
        ].join(' '),
        secondary: [
            'bg-eggs-secondary',
            'text-eggs-dark',
            'border-0',
            'hover:bg-eggs-secondary-hover',
            'focus:ring-eggs-secondary'
        ].join(' '),
        outline: [
            'bg-transparent',
            'text-eggs-dark',
            'border-2',
            'border-eggs-dark',
            'hover:bg-gray-50',
            'focus:ring-eggs-dark'
        ].join(' '),
        ghost: [
            'bg-transparent',
            'text-eggs-dark',
            'border-0',
            'hover:bg-gray-50',
            'focus:ring-eggs-dark'
        ].join(' '),
        inverse: [
            'bg-white',
            'text-eggs-dark',
            'border-0',
            'hover:bg-gray-50',
            'focus:ring-white'
        ].join(' ')
    };
    // Size-specific styles
    const sizeClasses = {
        lg: [
            'h-12',
            // 48px
            'px-6',
            // 24px
            'text-lg',
            // 18px
            'gap-3' // 12px
        ].join(' '),
        md: [
            'h-10',
            // 40px
            'px-4',
            // 16px
            'text-base',
            // 16px
            'gap-2' // 8px
        ].join(' '),
        sm: [
            'h-8',
            // 32px
            'px-4',
            // 16px
            'text-sm',
            // 14px
            'gap-2' // 8px
        ].join(' ')
    };
    // Icon sizes based on button size
    const iconSizes = {
        lg: 20,
        md: 18,
        sm: 16
    };
    const iconSize = iconSizes[size];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", _extends({
        className: `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`
    }, props), showLeadingIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: resolvedLeadingIcon,
        size: iconSize
    }), children, hasTrailingIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: trailingIcon,
        size: iconSize
    }));
}
const BrandButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "brand"
    }, props));
const PrimaryButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "primary"
    }, props));
const SecondaryButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "secondary"
    }, props));
const OutlineButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "outline"
    }, props));
const GhostButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "ghost"
    }, props));
const InverseButton = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Button, _extends({
        variant: "inverse"
    }, props));

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2XE8V":[function(require,module,exports,__globalThis) {
// EGGS Design System Components
// Phase 1 Components (Foundation)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "Text", ()=>(0, _textDefault.default));
parcelHelpers.export(exports, "H1", ()=>(0, _text.H1));
parcelHelpers.export(exports, "H2", ()=>(0, _text.H2));
parcelHelpers.export(exports, "H3", ()=>(0, _text.H3));
parcelHelpers.export(exports, "H4", ()=>(0, _text.H4));
parcelHelpers.export(exports, "H5", ()=>(0, _text.H5));
parcelHelpers.export(exports, "H6", ()=>(0, _text.H6));
parcelHelpers.export(exports, "Body", ()=>(0, _text.Body));
parcelHelpers.export(exports, "Caption", ()=>(0, _text.Caption));
parcelHelpers.export(exports, "Heading", ()=>(0, _text.Heading));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconDefault.default));
// Phase 2 Components (Forms & Layout)
// Form Components
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "SearchInput", ()=>(0, _input.SearchInput));
parcelHelpers.export(exports, "PasswordInput", ()=>(0, _input.PasswordInput));
parcelHelpers.export(exports, "EmailInput", ()=>(0, _input.EmailInput));
parcelHelpers.export(exports, "Textarea", ()=>(0, _textareaDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radio.RadioGroup));
// Social/OAuth Components
parcelHelpers.export(exports, "SocialButton", ()=>(0, _socialButtonDefault.default));
parcelHelpers.export(exports, "MicrosoftButton", ()=>(0, _socialButton.MicrosoftButton));
parcelHelpers.export(exports, "LinkedInButton", ()=>(0, _socialButton.LinkedInButton));
parcelHelpers.export(exports, "AppleButton", ()=>(0, _socialButton.AppleButton));
parcelHelpers.export(exports, "GoogleButton", ()=>(0, _socialButton.GoogleButton));
// Layout Components
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "SpeakerCard", ()=>(0, _card.SpeakerCard));
parcelHelpers.export(exports, "SessionCard", ()=>(0, _card.SessionCard));
parcelHelpers.export(exports, "ElevatedCard", ()=>(0, _card.ElevatedCard));
parcelHelpers.export(exports, "OutlinedCard", ()=>(0, _card.OutlinedCard));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "SmallContainer", ()=>(0, _container.SmallContainer));
parcelHelpers.export(exports, "MediumContainer", ()=>(0, _container.MediumContainer));
parcelHelpers.export(exports, "LargeContainer", ()=>(0, _container.LargeContainer));
parcelHelpers.export(exports, "ExtraLargeContainer", ()=>(0, _container.ExtraLargeContainer));
parcelHelpers.export(exports, "FullContainer", ()=>(0, _container.FullContainer));
parcelHelpers.export(exports, "Section", ()=>(0, _sectionDefault.default));
parcelHelpers.export(exports, "PrimarySection", ()=>(0, _section.PrimarySection));
parcelHelpers.export(exports, "SecondarySection", ()=>(0, _section.SecondarySection));
parcelHelpers.export(exports, "DarkSection", ()=>(0, _section.DarkSection));
parcelHelpers.export(exports, "LightSection", ()=>(0, _section.LightSection));
parcelHelpers.export(exports, "HeroSection", ()=>(0, _section.HeroSection));
// Feedback Components
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "SuccessAlert", ()=>(0, _alert.SuccessAlert));
parcelHelpers.export(exports, "ErrorAlert", ()=>(0, _alert.ErrorAlert));
parcelHelpers.export(exports, "WarningAlert", ()=>(0, _alert.WarningAlert));
parcelHelpers.export(exports, "InfoAlert", ()=>(0, _alert.InfoAlert));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ConfirmModal", ()=>(0, _modal.ConfirmModal));
parcelHelpers.export(exports, "AlertModal", ()=>(0, _modal.AlertModal));
parcelHelpers.export(exports, "ErrorFallback", ()=>(0, _errorFallbackDefault.default));
// Page Components
parcelHelpers.export(exports, "WelcomeScreen", ()=>(0, _welcomeScreenDefault.default));
// Development/Testing
parcelHelpers.export(exports, "DesignSystemTest", ()=>(0, _designSystemTestDefault.default));
// Booking Components
parcelHelpers.export(exports, "GondolaCard", ()=>(0, _gondolaCardDefault.default));
parcelHelpers.export(exports, "OnboardingBanner", ()=>(0, _onboardingBannerDefault.default));
parcelHelpers.export(exports, "SmartPicture", ()=>(0, _smartPictureDefault.default));
parcelHelpers.export(exports, "QRCode", ()=>(0, _qrcodeDefault.default));
parcelHelpers.export(exports, "StatusBadge", ()=>(0, _statusBadgeDefault.default));
parcelHelpers.export(exports, "STATUS_MAP", ()=>(0, _statusBadge.STATUS_MAP));
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _textarea = require("./Textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _radio = require("./Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _socialButton = require("./SocialButton");
var _socialButtonDefault = parcelHelpers.interopDefault(_socialButton);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _errorFallback = require("./ErrorFallback");
var _errorFallbackDefault = parcelHelpers.interopDefault(_errorFallback);
var _welcomeScreen = require("./WelcomeScreen");
var _welcomeScreenDefault = parcelHelpers.interopDefault(_welcomeScreen);
var _designSystemTest = require("./DesignSystemTest");
var _designSystemTestDefault = parcelHelpers.interopDefault(_designSystemTest);
var _gondolaCard = require("./GondolaCard");
var _gondolaCardDefault = parcelHelpers.interopDefault(_gondolaCard);
var _onboardingBanner = require("./OnboardingBanner");
var _onboardingBannerDefault = parcelHelpers.interopDefault(_onboardingBanner);
var _smartPicture = require("./SmartPicture");
var _smartPictureDefault = parcelHelpers.interopDefault(_smartPicture);
var _qrcode = require("./QRCode");
var _qrcodeDefault = parcelHelpers.interopDefault(_qrcode);
var _statusBadge = require("./StatusBadge");
var _statusBadgeDefault = parcelHelpers.interopDefault(_statusBadge);

},{"./Button":"gqkVm","./Text":"ilUQ0","./Icon":"62fBo","./Input":"802QL","./Textarea":"8tt99","./Select":"g1F58","./Checkbox":"iaKub","./Radio":"1Wgvt","./SocialButton":"fSKDF","./Card":"6QY7C","./Container":"dY39r","./Section":"cP5GB","./Alert":"8qMAn","./Modal":"i68rp","./ErrorFallback":"2AB8s","./WelcomeScreen":"3yWrR","./DesignSystemTest":"9amQp","./GondolaCard":"bnhse","./OnboardingBanner":"gE3fK","./SmartPicture":"aXsXZ","./QRCode":"3FKx2","./StatusBadge":"2nLze","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"802QL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Input);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Input(_param) {
    var { label, error, helperText, required = false, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "label",
        "error",
        "helperText",
        "required",
        "className"
    ]);
    const inputClasses = [
        'w-full',
        'px-4 py-3',
        'font-burns font-extralight text-base',
        'text-eggs-dark',
        'bg-white',
        'border rounded-lg',
        'transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-offset-1',
        error ? 'border-error focus:ring-error' : 'border-gray-300 focus:border-eggs-yellow focus:ring-eggs-yellow',
        'disabled:bg-gray-100 disabled:cursor-not-allowed',
        'placeholder:text-gray-400'
    ].join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `space-y-1.5 ${className}`
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: "block"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        weight: "Strong"
    }, label, required && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-error ml-1"
    }, "*"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", _extends({
        className: inputClasses
    }, props)), (error || helperText) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "xs",
        className: error ? 'text-error' : 'text-gray-500'
    }, error || helperText));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Text":"ilUQ0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8tt99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Textarea);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Textarea(_param) {
    var { label, error, helperText, required = false, rows = 4, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "label",
        "error",
        "helperText",
        "required",
        "rows",
        "className"
    ]);
    const textareaClasses = [
        'w-full',
        'px-4 py-3',
        'font-burns font-extralight text-base',
        'text-eggs-dark',
        'bg-white',
        'border rounded-lg',
        'transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-offset-1',
        'resize-vertical',
        error ? 'border-error focus:ring-error' : 'border-gray-300 focus:border-eggs-yellow focus:ring-eggs-yellow',
        'disabled:bg-gray-100 disabled:cursor-not-allowed',
        'placeholder:text-gray-400'
    ].join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `space-y-1.5 ${className}`
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: "block"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        weight: "Strong"
    }, label, required && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-error ml-1"
    }, "*"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("textarea", _extends({
        className: textareaClasses,
        rows: rows
    }, props)), (error || helperText) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "xs",
        className: error ? 'text-error' : 'text-gray-500'
    }, error || helperText));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Text":"ilUQ0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"g1F58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/**
 * EGGS Select Component
 * Based on EGGS Design System specifications
 * 
 * @param {string} variant - default | error | success
 * @param {string} size - lg | md | sm
 * @param {string} label - Select label
 * @param {string} helperText - Helper text below select
 * @param {string} errorText - Error message (overrides helperText)
 * @param {boolean} required - Required field indicator
 * @param {boolean} disabled - Disabled state
 * @param {string} placeholder - Placeholder text
 * @param {Array} options - Array of option objects {value, label}
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional select props
 */ const Select = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { variant = 'default', size = 'md', label, helperText, errorText, required = false, disabled = false, placeholder = 'Select an option...', options = [], className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "variant",
        "size",
        "label",
        "helperText",
        "errorText",
        "required",
        "disabled",
        "placeholder",
        "options",
        "className"
    ]);
    const isError = variant === 'error' || errorText;
    const isSuccess = variant === 'success';
    // Base classes for select container
    const containerClasses = [
        'relative',
        'w-full'
    ].join(' ');
    // Label classes
    const labelClasses = [
        'block',
        'font-burns',
        'font-normal',
        'text-eggs-dark',
        'mb-2',
        size === 'lg' ? 'text-base' : size === 'md' ? 'text-sm' : 'text-xs'
    ].join(' ');
    // Select wrapper classes
    const wrapperClasses = [
        'relative',
        'flex',
        'items-center'
    ].join(' ');
    // Base select classes
    const baseSelectClasses = [
        'w-full',
        'font-burns',
        'font-extralight',
        'bg-white',
        'border-2',
        'rounded-lg',
        'transition-all',
        'duration-200',
        'ease-in-out',
        'focus:outline-none',
        'focus:ring-2',
        'focus:ring-offset-1',
        'appearance-none',
        'cursor-pointer',
        disabled ? 'opacity-50 cursor-not-allowed' : ''
    ].join(' ');
    // Size-specific classes
    const sizeClasses = {
        lg: [
            'h-12',
            // 48px
            'px-4',
            // 16px
            'pr-12',
            // Extra padding for chevron
            'text-lg' // 18px
        ].join(' '),
        md: [
            'h-10',
            // 40px
            'px-3',
            // 12px
            'pr-10',
            // Extra padding for chevron
            'text-base' // 16px
        ].join(' '),
        sm: [
            'h-8',
            // 32px
            'px-3',
            // 12px
            'pr-9',
            // Extra padding for chevron
            'text-sm' // 14px
        ].join(' ')
    };
    // Variant-specific classes
    const variantClasses = {
        default: [
            'border-gray-300',
            'text-eggs-dark',
            'focus:border-eggs-yellow',
            'focus:ring-eggs-yellow/20'
        ].join(' '),
        error: [
            'border-error',
            'text-eggs-dark',
            'focus:border-error',
            'focus:ring-error/20'
        ].join(' '),
        success: [
            'border-success',
            'text-eggs-dark',
            'focus:border-success',
            'focus:ring-success/20'
        ].join(' ')
    };
    // Chevron positioning classes
    const chevronClasses = {
        lg: 'absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none',
        md: 'absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none',
        sm: 'absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none'
    };
    // Icon sizes based on select size
    const iconSizes = {
        lg: 20,
        md: 18,
        sm: 16
    };
    // Helper/error text classes
    const helperTextClasses = [
        'mt-2',
        'font-burns',
        'font-extralight',
        size === 'lg' ? 'text-sm' : 'text-xs',
        isError ? 'text-error' : isSuccess ? 'text-success' : 'text-gray-500'
    ].join(' ');
    const iconSize = iconSizes[size];
    const displayText = errorText || helperText;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${containerClasses} ${className}`
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: labelClasses
    }, label, required && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-error ml-1"
    }, "*")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperClasses
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("select", _extends({
        ref: ref,
        className: `${baseSelectClasses} ${sizeClasses[size]} ${variantClasses[isError ? 'error' : isSuccess ? 'success' : 'default']}`,
        disabled: disabled
    }, props), placeholder && /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
        value: "",
        disabled: true
    }, placeholder), options.map((option, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
            key: option.value || index,
            value: option.value
        }, option.label))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "chevron-down",
        size: iconSize,
        className: `${chevronClasses[size]} text-gray-500`
    })), displayText && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: helperTextClasses
    }, displayText));
});
Select.displayName = 'Select';
exports.default = Select;

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iaKub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/**
 * EGGS Checkbox Component
 * Based on EGGS Design System specifications
 * 
 * @param {string} size - lg | md | sm
 * @param {string} label - Checkbox label
 * @param {string} helperText - Helper text below checkbox
 * @param {string} errorText - Error message (overrides helperText)
 * @param {boolean} required - Required field indicator
 * @param {boolean} disabled - Disabled state
 * @param {boolean} indeterminate - Indeterminate state
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional checkbox props
 */ const Checkbox = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { size = 'md', label, helperText, errorText, required = false, disabled = false, indeterminate = false, className = '', checked, onChange } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "size",
        "label",
        "helperText",
        "errorText",
        "required",
        "disabled",
        "indeterminate",
        "className",
        "checked",
        "onChange"
    ]);
    const isError = errorText;
    // Base classes for checkbox container
    const containerClasses = [
        'relative',
        'flex',
        'items-start',
        'gap-3'
    ].join(' ');
    // Checkbox wrapper classes
    const checkboxWrapperClasses = [
        'relative',
        'flex',
        'items-center',
        'justify-center',
        'flex-shrink-0',
        'border-2',
        'rounded',
        'transition-all',
        'duration-200',
        'ease-in-out',
        'cursor-pointer',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        checked || indeterminate ? 'bg-eggs-yellow border-eggs-yellow' : 'bg-white border-gray-300',
        !disabled && !checked && !indeterminate ? 'hover:border-eggs-yellow' : '',
        isError ? 'border-error' : ''
    ].join(' ');
    // Size-specific classes
    const sizeClasses = {
        lg: {
            checkbox: 'w-6 h-6',
            icon: 16,
            label: 'text-lg',
            helper: 'text-sm'
        },
        md: {
            checkbox: 'w-5 h-5',
            icon: 14,
            label: 'text-base',
            helper: 'text-sm'
        },
        sm: {
            checkbox: 'w-4 h-4',
            icon: 12,
            label: 'text-sm',
            helper: 'text-xs'
        }
    };
    // Label classes
    const labelClasses = [
        'font-burns',
        'font-extralight',
        'text-eggs-dark',
        'cursor-pointer',
        'select-none',
        sizeClasses[size].label,
        disabled ? 'opacity-50 cursor-not-allowed' : ''
    ].join(' ');
    // Helper/error text classes
    const helperTextClasses = [
        'mt-1',
        'font-burns',
        'font-extralight',
        sizeClasses[size].helper,
        isError ? 'text-error' : 'text-gray-500'
    ].join(' ');
    const displayText = errorText || helperText;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${containerClasses} ${className}`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: "flex items-start gap-3 cursor-pointer min-h-[44px] py-2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: `${checkboxWrapperClasses} ${sizeClasses[size].checkbox}`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", _extends({
        ref: ref,
        type: "checkbox",
        className: "sr-only",
        disabled: disabled,
        checked: checked,
        onChange: (e)=>onChange && onChange(e.target.checked)
    }, props)), (checked || indeterminate) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: indeterminate ? 'minus' : 'check',
        size: sizeClasses[size].icon,
        className: "text-eggs-dark"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "flex-1"
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: labelClasses,
        dangerouslySetInnerHTML: {
            __html: (0, _dompurifyDefault.default).sanitize(label) + (required ? '<span class="text-error ml-1">*</span>' : '')
        }
    }), displayText && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: helperTextClasses
    }, displayText))));
});
Checkbox.displayName = 'Checkbox';
exports.default = Checkbox;

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","dompurify":"jWeBb","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jWeBb":[function(require,module,exports,__globalThis) {
/*! @license DOMPurify 3.4.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    const entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    let _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * Convert non-node values into strings without depending on direct property access.
   *
   * @param value - The value to stringify.
   * @returns A string representation of the provided value.
   */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'command',
        'commandfor',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.8';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
        _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        const getShadowRoot = lookupGetter(ElementPrototype, 'shadowRoot');
        const getAttributes = lookupGetter(ElementPrototype, 'attributes');
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeName') : null;
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        // Tracks whether we are already inside a call to the configured Trusted Types
        // policy's `createHTML`. If the supplied `TRUSTED_TYPES_POLICY.createHTML`
        // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
        // re-enter the policy and recurse until the stack overflows. We detect that
        // re-entry and throw a clear, actionable error instead.
        let IN_POLICY_CREATE_HTML = 0;
        const _createTrustedHTML = function _createTrustedHTML(html) {
            if (IN_POLICY_CREATE_HTML > 0) throw typeErrorCreate('The configured TRUSTED_TYPES_POLICY.createHTML must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose createHTML wraps DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
            IN_POLICY_CREATE_HTML++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_POLICY_CREATE_HTML--;
            }
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && arrayIsArray(cfg.ALLOWED_TAGS) ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && arrayIsArray(cfg.ALLOWED_ATTR) ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && arrayIsArray(cfg.ALLOWED_NAMESPACES) ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS) ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') && arrayIsArray(cfg.FORBID_TAGS) ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') && arrayIsArray(cfg.FORBID_ATTR) ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, [
                'mi',
                'mo',
                'mn',
                'ms',
                'mtext'
            ]); // Default built-in map
            HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, [
                'annotation-xml'
            ]); // Default built-in map
            const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
       * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`. If the supplied policy's
                // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
                // throws via the re-entrancy guard. Restore the previous policy first so
                // the instance is not left in a poisoned state. See #1422.
                try {
                    emptyHTML = _createTrustedHTML('');
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined && cfg.TRUSTED_TYPES_POLICY !== null) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                // Note: a falsy `trustedTypesPolicy` (null when policy creation failed or
                // was skipped via `TRUSTED_TYPES_POLICY: null`, or undefined when no
                // policy has been initialized yet) must be excluded here, otherwise we
                // would call `.createHTML` on a non-policy and throw. See #1422.
                if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
            }
            /*
       * Mirror the clone-before-mutate pattern already applied above for
       * cfg.ADD_TAGS / cfg.ADD_ATTR: if any uponSanitize* hook is
       * registered AND the set still points at the default constant,
       * clone it. The hook then mutates the clone (in-call widening
       * still works exactly as documented) and the next default-cfg
       * call rebinds to the untouched original via the reassignment at
       * the top of this function.
       */ if ((hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) && ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0 && ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
     * character data of an element subtree. Used as the final safety net for
     * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
     * which only form after text-node normalization (e.g. fragments split across
     * stripped elements) cannot survive into a template-evaluating framework.
     *
     * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
     * in place rather than round-tripping through innerHTML. This preserves
     * descendant node references (important for IN_PLACE callers), avoids a
     * serialize/reparse cycle, and reads literal character data — which means
     * `<%...%>` in text content matches the ERB regex against its real bytes
     * instead of the HTML-entity-escaped form innerHTML would produce.
     *
     * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
     * attributes is performed during the per-node `_sanitizeAttributes` pass.
     *
     * @param node The root element whose character data should be scrubbed.
     */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl, _node$querySelectorAl2;
            node.normalize();
            const walker = createNodeIterator.call(node.ownerDocument || node, node, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                let data = currentNode.data;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    data = stringReplace(data, expr, ' ');
                });
                currentNode.data = data;
                currentNode = walker.nextNode();
            }
            // NodeIterator does not descend into <template>.content per the DOM spec,
            // so we must explicitly recurse into each template's content fragment,
            // mirroring the approach used by _sanitizeShadowDOM.
            const templates = (_node$querySelectorAl = (_node$querySelectorAl2 = node.querySelectorAll) === null || _node$querySelectorAl2 === void 0 ? void 0 : _node$querySelectorAl2.call(node, 'template')) !== null && _node$querySelectorAl !== void 0 ? _node$querySelectorAl : [];
            arrayForEach(Array.from(templates), (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
     * _isClobbered
     *
     * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
     * interface with [LegacyOverrideBuiltIns]; a descendant element with a
     * `name` attribute matching a prototype property shadows that property
     * on direct reads. We use this check at the IN_PLACE entry-point and
     * during attribute sanitization to refuse clobbered forms.
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            // Realm-independent tag-name probe. If we can't determine the tag
            // name at all, we can't reason about clobbering — return false
            // (the caller's other defences still apply).
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== 'string') return false;
            if (transformCaseFunc(realTagName) !== 'form') return false;
            return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
            // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
            // makes the direct read diverge from the cached read; a clean form
            // (same-realm OR foreign-realm) has both reads pointing at the same
            // canonical NamedNodeMap.
            element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
            // returns the integer 1 for any Element regardless of realm; direct
            // read on a clobbered form (e.g. <input name="nodeType">) returns
            // the named child element. Cheap addition — nodeType is read from
            // an internal slot, no serialization cost — and removes a residual
            // clobbering surface used by several mXSS / PI / comment branches
            // in _sanitizeElements that compare currentNode.nodeType directly.
            element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
            // "childNodes" shadows the prototype getter. Direct reads of
            // form.childNodes from a clobbered form return the named child
            // instead of the real NodeList, so any walk that reads it directly
            // skips the form's real children. Compare the direct read to the
            // cached Node.prototype getter — when the form's named-property
            // getter intercepts the read, the two values differ and we flag
            // the form. This catches every clobbering child type (input,
            // select, etc.) regardless of whether the named child happens to
            // carry a numeric .length, which a typeof-based probe would miss
            // (e.g. HTMLSelectElement.length is a defined unsigned-long).
            element.childNodes !== getChildNodes(element);
        };
        /**
     * Checks whether the given value is a DocumentFragment from any realm.
     *
     * The realm-independent replacement reads `nodeType` through the cached
     * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
     * constant (11). nodeType is a numeric value resolved from the node's
     * internal slot, identical across realms for the same kind of node.
     *
     * @param value object to check
     * @return true if value is a DocumentFragment-shaped node from any realm
     */ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
     * Checks whether the given object is a DOM node, including nodes that
     * originate from a different window/realm (e.g. an iframe's
     * contentDocument). The previous `value instanceof Node` check was
     * realm-bound: nodes from a different window failed it, causing
     * sanitize() to silently stringify them and reset IN_PLACE to false,
     * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
     *
     * @param value object to check whether it's a DOM node
     * @return true if value is a DOM node from any realm
     */ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return typeof getNodeType(value) === 'number';
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements.
           Use the cached prototype getters exclusively — the previous code
           had `|| currentNode.parentNode` / `|| currentNode.childNodes`
           fallbacks, but the cached getters always return the canonical
           value (or null for a real parent-less node), so the fallback
           path was dead in safe cases and a clobbering surface in unsafe
           ones. Falsy cached results stay falsy; the `if (childNodes &&
           parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode);
                    const childNodes = getChildNodes(currentNode);
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
         nodeType getter rather than `instanceof Element`, which is realm-
         bound and short-circuits to false for any node minted in a different
         realm — letting a foreign-realm element with a forbidden namespace
         slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
            if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!nameIsPermitted || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
     * never be treated as basic custom elements even when a permissive
     * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = _createTrustedHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
           DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
           recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                /* An element iterated here may itself host an attached
           shadow root. The default NodeIterator does not enter shadow
           trees, so a shadow root nested inside template.content was
           previously reached by no walk at all (the pre-pass at
           _sanitizeAttachedShadowRoots descends via childNodes, which
           doesn't enter template.content; the template-content recursion
           above iterates the content but never inspected shadowRoot).
           Walk it explicitly. The nodeType guard avoids reading
           shadowRoot off text / comment / CDATA / PI nodes that the
           iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
                if (shadowNodeType === NODE_TYPE.element) {
                    const innerSr = getShadowRoot ? getShadowRoot(shadowNode) : shadowNode.shadowRoot;
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots2(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
     * _sanitizeAttachedShadowRoots
     *
     * Walks `root` and feeds every attached shadow root we encounter into
     * the existing _sanitizeShadowDOM pipeline. The default node iterator
     * does not descend into shadow trees, so nodes inside an attached
     * shadow root would otherwise be skipped entirely.
     *
     * Two real input paths put attached shadow roots in front of us:
     *   1. IN_PLACE on a DOM node that already has shadow roots attached.
     *   2. DOM-node input where importNode(dirty, true) deep-clones the
     *      shadow root because it was created with `clonable: true`.
     *
     * This pass runs once, up front, so the main iteration loop (and the
     * existing _sanitizeShadowDOM template-content recursion) stay
     * untouched — string-input paths are not affected.
     *
     * @param root the subtree root to walk for attached shadow roots
     */ const _sanitizeAttachedShadowRoots2 = function _sanitizeAttachedShadowRoots(root) {
            const nodeType = getNodeType ? getNodeType(root) : root.nodeType;
            if (nodeType === NODE_TYPE.element) {
                const sr = getShadowRoot ? getShadowRoot(root) : root.shadowRoot;
                // Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType-based
                // detection rather than `instanceof DocumentFragment`, which is
                // realm-bound and silently skipped shadow roots whose host element
                // belonged to a foreign realm (e.g. iframe.contentDocument
                // attachShadow). A foreign-realm ShadowRoot extends the foreign
                // realm's DocumentFragment, not ours, so the old instanceof check
                // returned false and the shadow subtree was never walked.
                if (_isDocumentFragment(sr)) {
                    // Recurse first so that nested shadow roots are reached even if
                    // _sanitizeShadowDOM removes hosts at this level.
                    _sanitizeAttachedShadowRoots2(sr);
                    _sanitizeShadowDOM2(sr);
                }
            }
            // Snapshot children before recursing. Sanitization of one subtree
            // (e.g. via an uponSanitizeShadowNode hook) may detach siblings,
            // and naive nextSibling traversal would silently skip the rest of
            // the list once a node is detached.
            const childNodes = getChildNodes ? getChildNodes(root) : root.childNodes;
            if (!childNodes) return;
            const snapshot = [];
            arrayForEach(childNodes, (child)=>{
                arrayPush(snapshot, child);
            });
            for (const child of snapshot)_sanitizeAttachedShadowRoots2(child);
            /* When the root is a <template>, also descend into root.content */ if (nodeType === NODE_TYPE.element) {
                const rootName = getNodeName ? getNodeName(root) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = root.content;
                    if (_isDocumentFragment(content)) _sanitizeAttachedShadowRoots2(content);
                }
            }
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) {
                /* Do some early pre-sanitization to avoid unsafe root nodes.
           Read nodeName through the cached prototype getter — a clobbering
           child named "nodeName" on the form root would otherwise shadow
           the property and let this check skip the root-allowlist
           validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
                /* Pre-flight the root through _isClobbered. The iterator-driven
           removal path can not detach a parent-less root: _forceRemove
           falls through to Element.prototype.remove(), which per spec
           is a no-op on a node with no parent. A clobbered root would
           then survive the main loop with its attributes uninspected,
           because _sanitizeAttributes early-returns on _isClobbered. The
           result would be an attacker-controlled form, complete with any
           event-handler attributes the caller passed in, handed back to
           the application unsanitized. Refuse to sanitize such a root
           the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) throw typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
                /* Sanitize attached shadow roots before the main iterator runs.
           The iterator does not descend into shadow trees. */ _sanitizeAttachedShadowRoots2(dirty);
            } else if (_isNode(dirty)) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
                /* Clonable shadow roots are deep-cloned by importNode(); sanitize
           them before the main iterator runs, since the iterator does not
           descend into shadow trees. The walk routes every read through a
           cached prototype getter so clobbering descendants on a form root
           cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots2(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR$1,
                ERB_EXPR$1,
                TMPLIT_EXPR$1
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

},{}],"1Wgvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/**
 * EGGS Radio Component
 * Based on EGGS Design System specifications
 * 
 * @param {string} size - lg | md | sm
 * @param {string} label - Radio label
 * @param {string} helperText - Helper text below radio
 * @param {string} errorText - Error message (overrides helperText)
 * @param {boolean} required - Required field indicator
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional radio props
 */ const Radio = /*#__PURE__*/ (0, _react.forwardRef)((_param, ref)=>{
    var { size = 'md', label, helperText, errorText, required = false, disabled = false, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "size",
        "label",
        "helperText",
        "errorText",
        "required",
        "disabled",
        "className"
    ]);
    const isError = errorText;
    // Base classes for radio container
    const containerClasses = [
        'relative',
        'flex',
        'items-start',
        'gap-3'
    ].join(' ');
    // Radio wrapper classes
    const radioWrapperClasses = [
        'relative',
        'flex',
        'items-center',
        'justify-center',
        'flex-shrink-0',
        'border-2',
        'rounded-full',
        'transition-all',
        'duration-200',
        'ease-in-out',
        'cursor-pointer',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        props.checked ? 'bg-white border-eggs-yellow' : 'bg-white border-gray-300',
        !disabled && !props.checked ? 'hover:border-eggs-yellow' : '',
        isError ? 'border-error' : ''
    ].join(' ');
    // Inner dot classes
    const dotClasses = [
        'rounded-full',
        'bg-eggs-yellow',
        'transition-all',
        'duration-200',
        'ease-in-out',
        props.checked ? 'scale-100' : 'scale-0'
    ].join(' ');
    // Size-specific classes
    const sizeClasses = {
        lg: {
            radio: 'w-6 h-6',
            dot: 'w-3 h-3',
            label: 'text-lg',
            helper: 'text-sm'
        },
        md: {
            radio: 'w-5 h-5',
            dot: 'w-2.5 h-2.5',
            label: 'text-base',
            helper: 'text-sm'
        },
        sm: {
            radio: 'w-4 h-4',
            dot: 'w-2 h-2',
            label: 'text-sm',
            helper: 'text-xs'
        }
    };
    // Label classes
    const labelClasses = [
        'font-burns',
        'font-extralight',
        'text-eggs-dark',
        'cursor-pointer',
        'select-none',
        sizeClasses[size].label,
        disabled ? 'opacity-50 cursor-not-allowed' : ''
    ].join(' ');
    // Helper/error text classes
    const helperTextClasses = [
        'mt-1',
        'font-burns',
        'font-extralight',
        sizeClasses[size].helper,
        isError ? 'text-error' : 'text-gray-500'
    ].join(' ');
    const displayText = errorText || helperText;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${containerClasses} ${className}`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-start gap-3"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${radioWrapperClasses} ${sizeClasses[size].radio}`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", _extends({
        ref: ref,
        type: "radio",
        className: "sr-only",
        disabled: disabled
    }, props)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${dotClasses} ${sizeClasses[size].dot}`
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1"
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: labelClasses
    }, label, required && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-error ml-1"
    }, "*")), displayText && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: helperTextClasses
    }, displayText))));
});
Radio.displayName = 'Radio';
const RadioGroup = ({ label, required = false, errorText, helperText, children, className = '', size = 'md' })=>{
    const isError = errorText;
    // Label classes
    const labelClasses = [
        'block',
        'font-burns',
        'font-normal',
        'text-eggs-dark',
        'mb-3',
        size === 'lg' ? 'text-base' : size === 'md' ? 'text-sm' : 'text-xs'
    ].join(' ');
    // Helper/error text classes
    const helperTextClasses = [
        'mt-2',
        'font-burns',
        'font-extralight',
        size === 'lg' ? 'text-sm' : 'text-xs',
        isError ? 'text-error' : 'text-gray-500'
    ].join(' ');
    const displayText = errorText || helperText;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `space-y-2 ${className}`
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: labelClasses
    }, label, required && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-error ml-1"
    }, "*")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-3"
    }, children), displayText && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: helperTextClasses
    }, displayText));
};
exports.default = Radio;

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fSKDF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SocialButton);
// Convenience exports
parcelHelpers.export(exports, "MicrosoftButton", ()=>MicrosoftButton);
parcelHelpers.export(exports, "LinkedInButton", ()=>LinkedInButton);
parcelHelpers.export(exports, "AppleButton", ()=>AppleButton);
parcelHelpers.export(exports, "GoogleButton", ()=>GoogleButton);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function SocialButton(_param) {
    var { provider, // 'microsoft' | 'linkedin' | 'apple' | 'google'
    children, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "provider",
        "children",
        "className"
    ]);
    const providerStyles = {
        microsoft: {
            bg: 'bg-white',
            hover: 'hover:bg-gray-50',
            text: 'text-[#5E5E5E]',
            border: 'border border-[#8C8C8C]',
            icon: 'microsoft',
            iconSize: 20
        },
        linkedin: {
            bg: 'bg-[#0A66C2]',
            hover: 'hover:bg-[#004182]',
            text: 'text-white',
            icon: 'linkedin',
            iconSize: 20
        },
        apple: {
            bg: 'bg-black',
            hover: 'hover:bg-gray-900',
            text: 'text-white',
            icon: 'apple',
            iconSize: 18
        },
        google: {
            bg: 'bg-white',
            hover: 'hover:bg-gray-50',
            text: 'text-[#3C4043]',
            border: 'border border-[#DADCE0]',
            icon: 'google',
            iconSize: 18
        }
    };
    const style = providerStyles[provider] || providerStyles.microsoft;
    const buttonClasses = [
        'inline-flex items-center justify-center gap-3',
        'w-full h-11 px-6',
        'font-burns font-medium text-[15px]',
        'rounded-md',
        'transition-all duration-150',
        'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-eggs-yellow',
        'shadow-sm',
        style.bg,
        style.hover,
        style.text,
        style.border || '',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
    ].join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", _extends({
        className: buttonClasses
    }, props), style.icon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: style.icon,
        size: style.iconSize
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, children));
}
function MicrosoftButton(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SocialButton, _extends({
        provider: "microsoft"
    }, props));
}
function LinkedInButton(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SocialButton, _extends({
        provider: "linkedin"
    }, props));
}
function AppleButton(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SocialButton, _extends({
        provider: "apple"
    }, props));
}
function GoogleButton(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SocialButton, _extends({
        provider: "google"
    }, props));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6QY7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Card);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Card(_param) {
    var { title, subtitle, children, footer, variant = 'default', noPadding = false, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "title",
        "subtitle",
        "children",
        "footer",
        "variant",
        "noPadding",
        "className"
    ]);
    const variantClasses = {
        default: 'bg-white border border-gray-200',
        elevated: 'bg-white shadow-lg',
        outlined: 'bg-white border-2 border-eggs-dark',
        filled: 'bg-gray-100 border border-gray-200'
    };
    const cardClasses = [
        'rounded-lg overflow-hidden',
        'transition-all duration-200',
        variantClasses[variant],
        className
    ].join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: cardClasses
    }, props), (title || subtitle) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "px-6 py-4 border-b border-gray-200"
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h4",
        className: "mb-1"
    }, title), subtitle && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        className: "text-gray-600"
    }, subtitle)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: noPadding ? '' : 'px-6 py-4'
    }, children), footer && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "px-6 py-4 bg-gray-50 border-t border-gray-200"
    }, footer));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Text":"ilUQ0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dY39r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Container);
parcelHelpers.export(exports, "SmallContainer", ()=>SmallContainer);
parcelHelpers.export(exports, "MediumContainer", ()=>MediumContainer);
parcelHelpers.export(exports, "LargeContainer", ()=>LargeContainer);
parcelHelpers.export(exports, "ExtraLargeContainer", ()=>ExtraLargeContainer);
parcelHelpers.export(exports, "FullContainer", ()=>FullContainer);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Container(_param) {
    var { size = 'lg', centered = true, padding = 'md', children, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "size",
        "centered",
        "padding",
        "children",
        "className"
    ]);
    // Base classes for all containers
    const baseClasses = [
        'w-full',
        centered ? 'mx-auto' : ''
    ].join(' ');
    // Size-specific max-width classes
    const sizeClasses = {
        sm: 'max-w-sm',
        // 384px
        md: 'max-w-md',
        // 448px
        lg: 'max-w-4xl',
        // 896px - Good for main content
        xl: 'max-w-6xl',
        // 1152px - Wide layouts
        full: 'max-w-none' // No max width
    };
    // Padding classes
    const paddingClasses = {
        none: '',
        sm: 'px-4 py-2',
        md: 'px-6 py-4',
        lg: 'px-8 py-6',
        xl: 'px-12 py-8'
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: `${baseClasses} ${sizeClasses[size]} ${paddingClasses[padding]} ${className}`
    }, props), children);
}
const SmallContainer = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, _extends({
        size: "sm"
    }, props));
const MediumContainer = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, _extends({
        size: "md"
    }, props));
const LargeContainer = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, _extends({
        size: "lg"
    }, props));
const ExtraLargeContainer = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, _extends({
        size: "xl"
    }, props));
const FullContainer = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Container, _extends({
        size: "full"
    }, props));

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cP5GB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
parcelHelpers.export(exports, "PrimarySection", ()=>PrimarySection);
parcelHelpers.export(exports, "SecondarySection", ()=>SecondarySection);
parcelHelpers.export(exports, "DarkSection", ()=>DarkSection);
parcelHelpers.export(exports, "LightSection", ()=>LightSection);
parcelHelpers.export(exports, "HeroSection", ()=>HeroSection);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Section(_param) {
    var { variant = 'default', spacing = 'lg', fullHeight = false, children, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "variant",
        "spacing",
        "fullHeight",
        "children",
        "className"
    ]);
    // Base classes for all sections
    const baseClasses = [
        'w-full',
        fullHeight ? 'min-h-screen' : ''
    ].join(' ');
    // Variant-specific styles
    const variantClasses = {
        default: [
            'bg-white',
            'text-eggs-dark'
        ].join(' '),
        primary: [
            'bg-eggs-yellow',
            'text-eggs-dark'
        ].join(' '),
        secondary: [
            'bg-gray-100',
            'text-eggs-dark'
        ].join(' '),
        dark: [
            'bg-eggs-dark',
            'text-white'
        ].join(' '),
        light: [
            'bg-gray-50',
            'text-eggs-dark'
        ].join(' ')
    };
    // Spacing classes (vertical padding)
    const spacingClasses = {
        none: '',
        sm: 'py-8',
        // 32px
        md: 'py-12',
        // 48px
        lg: 'py-16',
        // 64px
        xl: 'py-24' // 96px
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", _extends({
        className: `${baseClasses} ${variantClasses[variant]} ${spacingClasses[spacing]} ${className}`
    }, props), children);
}
const PrimarySection = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Section, _extends({
        variant: "primary"
    }, props));
const SecondarySection = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Section, _extends({
        variant: "secondary"
    }, props));
const DarkSection = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Section, _extends({
        variant: "dark"
    }, props));
const LightSection = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Section, _extends({
        variant: "light"
    }, props));
const HeroSection = (props)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Section, _extends({
        fullHeight: true,
        spacing: "xl"
    }, props));

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8qMAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Alert);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Alert(_param) {
    var { variant = 'info', title, children, onClose, className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "variant",
        "title",
        "children",
        "onClose",
        "className"
    ]);
    const variants = {
        success: {
            bg: 'bg-green-50',
            border: 'border-green-200',
            text: 'text-green-800',
            icon: 'check-circle',
            iconColor: '#28A745'
        },
        error: {
            bg: 'bg-red-50',
            border: 'border-red-200',
            text: 'text-red-800',
            icon: 'alert-circle',
            iconColor: '#DC3545'
        },
        warning: {
            bg: 'bg-yellow-50',
            border: 'border-yellow-200',
            text: 'text-yellow-800',
            icon: 'alert-triangle',
            iconColor: '#FFC107'
        },
        info: {
            bg: 'bg-blue-50',
            border: 'border-blue-200',
            text: 'text-blue-800',
            icon: 'info',
            iconColor: '#FEC626'
        }
    };
    const config = variants[variant];
    const alertClasses = [
        'flex items-start gap-3',
        'p-4 rounded-lg border',
        config.bg,
        config.border,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: alertClasses,
        role: "alert"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: config.icon,
        size: 20,
        color: config.iconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1"
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        weight: "Strong",
        className: config.text
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        className: config.text
    }, children)), onClose && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: onClose,
        className: "text-gray-400 hover:text-gray-600 transition-colors",
        "aria-label": "Close alert"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "x",
        size: 18
    })));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Icon":"62fBo","./Text":"ilUQ0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"i68rp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Modal);
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function Modal(_param) {
    var { isOpen, onClose, title, children, footer, size = 'md', className = '' } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "isOpen",
        "onClose",
        "title",
        "children",
        "footer",
        "size",
        "className"
    ]);
    const sizes = {
        sm: 'max-w-md',
        md: 'max-w-2xl',
        lg: 'max-w-4xl',
        xl: 'max-w-6xl',
        full: 'max-w-full mx-4'
    };
    (0, _react.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
        return ()=>{
            document.body.style.overflow = 'unset';
        };
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm",
        onClick: onClose
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `bg-white rounded-lg shadow-2xl w-full ${sizes[size]} ${className} animate-fade-in`,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-center justify-between px-6 py-4 border-b border-gray-200"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h3"
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: onClose,
        className: "text-gray-400 hover:text-gray-600 transition-colors p-1",
        "aria-label": "Close modal"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "x",
        size: 24
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "px-6 py-4 max-h-[70vh] overflow-y-auto"
    }, children), footer && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-center justify-end gap-3 px-6 py-4 bg-gray-50 border-t border-gray-200"
    }, footer)));
}

},{"@swc/helpers/_/_object_without_properties":"13dVA","react":"lbBKc","./Icon":"62fBo","./Text":"ilUQ0","./Button":"gqkVm","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3yWrR":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WelcomeScreen);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _index = require("./index");
var _msalAuthService = require("../services/msalAuthService");
function WelcomeScreen() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const initiateOAuthLogin = async (provider)=>{
        const { signInWithRedirect, getCurrentUser, signOut } = await require("a8f84f04a12e2490");
        try {
            await getCurrentUser();
            await signOut();
        } catch (e) {
        // No existing session — proceed
        }
        const originalSetItem = sessionStorage.setItem.bind(sessionStorage);
        sessionStorage.setItem = function(key, value) {
            originalSetItem(key, value);
            if (key.includes('code_verifier') || key.includes('pkce')) localStorage.setItem(key, value);
        };
        await signInWithRedirect({
            provider: {
                custom: provider
            }
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "w-full max-w-md"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "text-center mb-10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "w-24 h-24 bg-eggs-yellow rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-5xl"
    }, "\uD83E\uDD0D")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Text), {
        type: "Heading",
        variant: "h1",
        className: "text-eggs-dark mb-3"
    }, "eggs Connect"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Text), {
        type: "Body",
        variant: "lg",
        className: "text-gray-600 mb-2"
    }, "Digital Customer Experience Days"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Text), {
        type: "Body",
        variant: "Base",
        className: "text-gray-500"
    }, "Vernetze dich mit Experten und Speakern")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-white rounded-2xl shadow-xl p-8 mb-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Text), {
        type: "Heading",
        variant: "h2",
        as: "h2",
        className: "text-center mb-6 text-gray-800"
    }, "Anmelden"), error && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Alert), {
        type: "error",
        className: "mb-3"
    }, error), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-3 mb-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.MicrosoftButton), {
        disabled: isLoading,
        onClick: async ()=>{
            setError('');
            setIsLoading(true);
            try {
                await (0, _msalAuthService.msalAuthService).login();
                navigate('/');
            } catch (err) {
                if (err.errorCode === 'user_cancelled') return;
                setError(err.message || 'Microsoft-Login fehlgeschlagen');
            } finally{
                setIsLoading(false);
            }
        }
    }, "Mit Microsoft anmelden"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LinkedInButton), {
        disabled: isLoading,
        onClick: ()=>initiateOAuthLogin('LinkedIn')
    }, "Mit LinkedIn anmelden")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "relative my-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "absolute inset-0 flex items-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "w-full border-t border-gray-200"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "relative flex justify-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "px-4 bg-white text-sm text-gray-500"
    }, "oder"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>navigate('/login'),
        className: "w-full h-11 px-6 text-[15px] font-medium text-eggs-dark hover:text-eggs-dark border-2 border-eggs-yellow hover:border-eggs-yellow-hover bg-eggs-yellow hover:bg-eggs-yellow-hover rounded-md transition-all"
    }, "Mit E-Mail anmelden")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Text), {
        type: "Body",
        variant: "sm",
        className: "text-gray-600"
    }, "Noch kein Konto?", ' ', /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: ()=>navigate('/register'),
        className: "text-eggs-dark font-semibold hover:text-eggs-yellow-hover underline"
    }, "Jetzt registrieren")))));
}

},{"react":"lbBKc","react-router-dom":"lDmut","./index":"2XE8V","../services/msalAuthService":"63JvP","a8f84f04a12e2490":"hWoST","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"63JvP":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * MSAL Auth Service — Microsoft Multi-Tenant Login via Custom Auth Challenge
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "msalAuthService", ()=>msalAuthService);
var _auth = require("aws-amplify/auth");
const AZURE_CLIENT_ID = "f07a0934-d4bb-40a4-bb5e-692777bfb88b";
const msalConfig = {
    auth: {
        clientId: AZURE_CLIENT_ID,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'sessionStorage'
    }
};
let msalInstance = null;
let initialized = false;
async function getMsalInstance() {
    if (!msalInstance) {
        const { PublicClientApplication } = await require("5001205685ea4f68");
        msalInstance = new PublicClientApplication(msalConfig);
    }
    if (!initialized) {
        await msalInstance.initialize();
        initialized = true;
    }
    return msalInstance;
}
// Generate a secure random password for the Cognito user (never used by user)
function generateRandomPassword() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%';
    const array = new Uint8Array(24);
    crypto.getRandomValues(array);
    return Array.from(array, (b)=>chars[b % chars.length]).join('');
}
const msalAuthService = {
    async login () {
        const instance = await getMsalInstance();
        // Step 1: Authenticate with Microsoft via popup
        const loginResponse = await instance.loginPopup({
            scopes: [
                'openid',
                'email',
                'profile'
            ]
        });
        const idToken = loginResponse.idToken;
        const email = (loginResponse.idTokenClaims.email || loginResponse.idTokenClaims.preferred_username).toLowerCase();
        const name = loginResponse.idTokenClaims.name || email.split('@')[0];
        // Step 2: Try Cognito Custom Auth signIn first (existing user)
        try {
            const { nextStep } = await (0, _auth.signIn)({
                username: email,
                options: {
                    authFlowType: 'CUSTOM_WITHOUT_SRP'
                }
            });
            if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
                const { confirmSignIn } = await require("f7f872323dbcc99d");
                await confirmSignIn({
                    challengeResponse: idToken
                });
            }
            return {
                email,
                name
            };
        } catch (signInError) {
            var _signInError_message, _signInError_message1;
            // User doesn't exist yet — sign up
            // Note: PreventUserExistenceErrors makes Cognito return generic "Incorrect username or password"
            if (signInError.name === 'UserNotFoundException' || signInError.name === 'NotAuthorizedException' || ((_signInError_message = signInError.message) === null || _signInError_message === void 0 ? void 0 : _signInError_message.includes('User does not exist')) || ((_signInError_message1 = signInError.message) === null || _signInError_message1 === void 0 ? void 0 : _signInError_message1.includes('Incorrect username or password'))) {
                const password = generateRandomPassword();
                try {
                    await (0, _auth.signUp)({
                        username: email,
                        password,
                        options: {
                            userAttributes: {
                                email,
                                name
                            },
                            // Send token via both paths — Amplify v6 has a known bug where
                            // clientMetadata is not reliably passed to Pre-Sign-Up Lambda
                            clientMetadata: {
                                msalIdToken: idToken
                            },
                            validationData: {
                                msalIdToken: idToken
                            }
                        }
                    });
                } catch (signUpError) {
                    // Race condition: user was created between signIn and signUp
                    if (signUpError.name !== 'UsernameExistsException') throw signUpError;
                }
                // After signup (auto-confirmed by PreSignUp Lambda), sign in with custom challenge
                const { nextStep } = await (0, _auth.signIn)({
                    username: email,
                    options: {
                        authFlowType: 'CUSTOM_WITHOUT_SRP'
                    }
                });
                if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
                    const { confirmSignIn } = await require("f7f872323dbcc99d");
                    await confirmSignIn({
                        challengeResponse: idToken
                    });
                }
                return {
                    email,
                    name
                };
            }
            throw signInError;
        }
    }
};

},{"aws-amplify/auth":"3cRL1","5001205685ea4f68":"ajdvr","f7f872323dbcc99d":"hWoST","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ajdvr":[function(require,module,exports,__globalThis) {
module.exports = require("24770d38be3607f6")(module.bundle.resolve("dist.93cd48d7.js")).catch((err)=>{
    delete module.bundle.cache[module.id];
    throw err;
}).then(()=>module.bundle.root('jfgzI'));

},{"24770d38be3607f6":"4IFe7"}],"4IFe7":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("cb10c786850188bf");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"cb10c786850188bf":"kd3El"}],"kd3El":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"hWoST":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("3cRL1"));

},{}],"9amQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DesignSystemTest);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _textarea = require("./Textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
function DesignSystemTest() {
    const [modalOpen, setModalOpen] = (0, _react.useState)(false);
    const [bookingState, setBookingState] = (0, _react.useState)('default');
    const [fakeBooking, setFakeBooking] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-8 max-w-6xl mx-auto space-y-12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Booking Flow Components"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-8"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-wrap gap-2"
    }, [
        'default',
        'loading',
        'sold-out-error',
        'generic-error',
        'sold-out',
        'not-found'
    ].map((s)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            key: s,
            size: "sm",
            variant: bookingState === s ? 'brand' : 'outline',
            onClick: ()=>{
                setBookingState(s);
                setFakeBooking(s === 'loading');
            }
        }, s))), bookingState !== 'sold-out' && bookingState !== 'not-found' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "relative bg-gray-900/20 rounded-3xl p-4 sm:p-8 flex items-end sm:items-center justify-center min-h-[500px]"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-white w-full sm:max-w-md sm:rounded-3xl rounded-t-3xl shadow-2xl overflow-hidden animate-fade-in"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-eggs-yellow px-6 pt-6 pb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-start justify-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1 pr-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
        variant: "sm",
        className: "text-eggs-dark/60 mb-1"
    }, "Gondel-Session buchen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "text-eggs-dark leading-tight"
    }, "Serverless Apps auf dem Riesenrad")), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        className: "w-10 h-10 flex items-center justify-center rounded-full bg-eggs-dark/10 hover:bg-eggs-dark/20 transition-colors shrink-0",
        "aria-label": "Schlie\xDFen"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-eggs-dark text-lg"
    }, "\u2715")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "px-6 py-5"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-center gap-3 mb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong",
        className: "text-eggs-dark"
    }, "Max Mustermann"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm",
        className: "text-gray-500"
    }, "eggs unimedia GmbH")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-gray-100 rounded-xl px-3 py-2 text-center shrink-0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm",
        weight: "Strong",
        className: "text-eggs-dark"
    }, "14:00"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
        variant: "xs",
        className: "text-gray-500"
    }, "Uhr"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-green-50 rounded-xl px-4 py-2.5 mb-5 flex items-center gap-2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "w-2 h-2 bg-green-500 rounded-full shrink-0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm",
        weight: "Strong",
        className: "text-green-800"
    }, "3 Pl\xE4tze verf\xFCgbar")), bookingState === 'sold-out-error' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-red-50 rounded-xl px-4 py-3 mb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm",
        className: "text-red-700"
    }, "Dieser Platz ist leider nicht mehr verf\xFCgbar. Die Verf\xFCgbarkeit wurde aktualisiert.")), bookingState === 'generic-error' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-red-50 rounded-xl px-4 py-3 mb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm",
        className: "text-red-700"
    }, "Buchung fehlgeschlagen. Bitte versuche es erneut.")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-col gap-3"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "brand",
        size: "lg",
        disabled: fakeBooking,
        className: "min-h-[48px] w-full"
    }, fakeBooking ? 'Wird gebucht...' : "\uD83C\uDFA1 Platz buchen"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "ghost",
        size: "md",
        className: "min-h-[48px] w-full"
    }, "Abbrechen"))))), bookingState === 'sold-out' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "relative bg-gray-100 rounded-3xl p-8 flex items-center justify-center min-h-[400px]"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-white rounded-3xl shadow-lg p-8 max-w-sm w-full text-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "text-red-500"
    }, "\u2715")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-2"
    }, "Ausgebucht"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        className: "text-gray-500 mb-6"
    }, "Diese Gondel-Session hat leider keine freien Pl\xE4tze mehr."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "secondary",
        size: "md",
        className: "min-h-[48px] w-full"
    }, "\u2190 Zur\xFCck"))), bookingState === 'not-found' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "relative bg-gray-100 rounded-3xl p-8 flex items-center justify-center min-h-[400px]"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "bg-white rounded-3xl shadow-lg p-8 max-w-sm w-full text-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-2"
    }, "Gondel nicht gefunden"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        className: "text-gray-500 mb-6"
    }, "Diese Session existiert leider nicht."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "secondary",
        size: "md",
        className: "min-h-[48px] w-full"
    }, "\u2190 Zur\xFCck zu den Gondel-Sessions"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Typography System"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H1), null, "Heading 1 - Main Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), null, "Heading 2 - Section Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), null, "Heading 3 - Subsection"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h4"
    }, "Heading 4 - Component Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h5"
    }, "Heading 5 - Small Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h6"
    }, "Heading 6 - Micro Title"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "lg"
    }, "Body Large - Lorem ipsum dolor sit amet, consectetur adipiscing elit."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "Body Base - Default body text for most content areas."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "sm"
    }, "Body Small - Secondary information and details."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        variant: "xs"
    }, "Body Extra Small - Fine print and metadata."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong"
    }, "Body Strong - Emphasized content that needs attention."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
        variant: "lg"
    }, "Caption Large - Section Labels"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), null, "Caption Base - Default Labels"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
        variant: "sm"
    }, "Caption Small - Micro Labels"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
        variant: "xs"
    }, "Caption Extra Small - Tiny Labels"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Button System"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Button Sizes"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-wrap gap-4 items-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        size: "lg"
    }, "Large Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        size: "md"
    }, "Medium Button"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        size: "sm"
    }, "Small Button"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Button Variants"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-wrap gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "brand"
    }, "Brand"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "primary"
    }, "Primary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "secondary"
    }, "Secondary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "outline"
    }, "Outline"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "ghost"
    }, "Ghost"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "inverse"
    }, "Inverse"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Buttons with Icons"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-wrap gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        hasLeadingIcon: true,
        leadingIcon: "arrow-left"
    }, "Back"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        hasTrailingIcon: true,
        trailingIcon: "arrow-right"
    }, "Continue"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        hasLeadingIcon: true,
        leadingIcon: "plus"
    }, "Add Item"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        hasTrailingIcon: true,
        trailingIcon: "chevron-down",
        variant: "outline"
    }, "Menu"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Disabled States"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex flex-wrap gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        disabled: true
    }, "Disabled Brand"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "primary",
        disabled: true
    }, "Disabled Primary"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        variant: "outline",
        disabled: true
    }, "Disabled Outline"))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Icon System"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Icon Sizes"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex items-center gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "star",
        size: 16
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "star",
        size: 20
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "star",
        size: 24
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "star",
        size: 32
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "star",
        size: 48
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-4"
    }, "Common Icons"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "grid grid-cols-8 gap-4"
    }, [
        'arrow-right',
        'arrow-left',
        'chevron-right',
        'chevron-down',
        'user',
        'users',
        'settings',
        'menu',
        'x',
        'search',
        'bell',
        'message-circle',
        'calendar',
        'home',
        'star',
        'check',
        'check-circle',
        'alert-circle',
        'info',
        'plus',
        'edit',
        'trash-2'
    ].map((iconName)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            key: iconName,
            className: "flex flex-col items-center gap-2 p-2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
            name: iconName,
            size: 24
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), {
            variant: "xs"
        }, iconName))))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Form Components (Phase 2)"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-6 max-w-2xl"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputDefault.default), {
        label: "Email Address",
        type: "email",
        placeholder: "your@email.com",
        helperText: "We'll never share your email",
        required: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputDefault.default), {
        label: "Password",
        type: "password",
        placeholder: "Enter password",
        error: "Password must be at least 8 characters"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textareaDefault.default), {
        label: "Message",
        placeholder: "Type your message here...",
        rows: 4,
        helperText: "Maximum 500 characters"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Card Components (Phase 2)"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardDefault.default), {
        title: "Default Card",
        subtitle: "Standard card with border"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "This is a default card with white background and subtle border.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardDefault.default), {
        title: "Elevated Card",
        subtitle: "Card with shadow",
        variant: "elevated"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "This card has a shadow for emphasis.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardDefault.default), {
        title: "Outlined Card",
        subtitle: "Bold border card",
        variant: "outlined"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "This card has a bold EGGS dark border.")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardDefault.default), {
        title: "Filled Card",
        subtitle: "Gray background",
        variant: "filled",
        footer: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            size: "sm",
            variant: "outline"
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            size: "sm"
        }, "Confirm"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "This card has a light gray background with footer actions.")))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Alert Components (Phase 2)"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-4 max-w-2xl"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        variant: "success",
        title: "Success!"
    }, "Your changes have been saved successfully."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        variant: "error",
        title: "Error"
    }, "There was a problem processing your request."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        variant: "warning",
        title: "Warning"
    }, "This action cannot be undone. Please proceed with caution."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        variant: "info",
        title: "Information"
    }, "The event will start in 30 minutes. Please be ready."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        variant: "success",
        onClose: ()=>alert('Alert closed')
    }, "Dismissible alert with close button."))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Modal Component (Phase 2)"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        onClick: ()=>setModalOpen(true)
    }, "Open Modal"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Responsive Behavior"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "Resize the window to test responsive typography scaling."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-gray-50 rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-2"
    }, "Mobile First"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "Text scales appropriately across breakpoints.")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-gray-50 rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-2"
    }, "Tablet View"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "Medium screens maintain readability.")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-gray-50 rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H3), {
        className: "mb-2"
    }, "Desktop View"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "Large screens show full typography scale."))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.H2), {
        className: "mb-6"
    }, "Color System"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "grid grid-cols-2 md:grid-cols-4 gap-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-[#FEC626] text-[#35333A] rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong"
    }, "EGGS Yellow"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), null, "#FEC626")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-[#35333A] text-white rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong"
    }, "EGGS Dark"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), null, "#35333A")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-[#EFECEC] text-[#35333A] rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong"
    }, "EGGS Light"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), null, "#EFECEC")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "p-4 bg-white text-[#35333A] border border-gray-200 rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), {
        weight: "Strong"
    }, "White"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Caption), null, "#FFFFFF")))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDefault.default), {
        isOpen: modalOpen,
        onClose: ()=>setModalOpen(false),
        title: "Example Modal",
        footer: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            variant: "outline",
            onClick: ()=>setModalOpen(false)
        }, "Cancel"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            onClick: ()=>setModalOpen(false)
        }, "Confirm"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "space-y-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Body), null, "This is an example modal dialog with EGGS styling."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputDefault.default), {
        label: "Name",
        placeholder: "Enter your name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textareaDefault.default), {
        label: "Comments",
        placeholder: "Add your comments...",
        rows: 3
    }))));
}

},{"react":"lbBKc","./Button":"gqkVm","./Text":"ilUQ0","./Icon":"62fBo","./Input":"802QL","./Textarea":"8tt99","./Card":"6QY7C","./Alert":"8qMAn","./Modal":"i68rp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bnhse":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GondolaCard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function GondolaCard({ title, speakers = [], time, date, availableSlots, soldOut = false, booked = false, bookingStatus, cancelled = false, onClick }) {
    const disabled = (soldOut || cancelled) && !booked;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        tabIndex: disabled ? -1 : 0,
        "aria-disabled": disabled,
        className: [
            'min-h-[48px] rounded-lg transition-all duration-200',
            disabled ? 'opacity-50 cursor-default' : 'cursor-pointer hover:shadow-md'
        ].join(' '),
        onClick: disabled ? undefined : onClick,
        onKeyDown: (e)=>{
            if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardDefault.default), {
        variant: "elevated",
        className: "border-l-2 border-l-eggs-yellow"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex justify-between items-start gap-2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "flex-1 min-w-0"
    }, (date || time) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Caption",
        variant: "sm",
        weight: "Strong",
        className: "text-eggs-yellow mb-0.5"
    }, [
        date,
        time ? `${time} Uhr` : ''
    ].filter(Boolean).join(" \xb7 ")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h4",
        className: "mb-1"
    }, title), speakers.length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        className: "text-gray-600"
    }, speakers.map((s)=>s.fullName).join(' & '))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "text-right shrink-0"
    }, booked ? bookingStatus === 'checked-in' ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Caption",
        variant: "xs",
        className: "inline-flex items-center gap-1 px-2 py-1 font-medium bg-status-experienced-bg text-status-experienced-text rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "award",
        size: 14,
        color: "#7c3aed"
    }), "Erlebt") : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Caption",
        variant: "xs",
        className: "inline-flex items-center gap-1 px-2 py-1 font-medium bg-status-booked-bg text-status-booked-text rounded"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        name: "check-circle",
        size: 14,
        color: "#16a34a"
    }), "Gebucht") : cancelled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Caption",
        variant: "xs",
        className: "inline-block px-2 py-1 font-medium bg-gray-100 text-gray-600 rounded"
    }, "\u26A0\uFE0F Storniert") : soldOut ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Caption",
        variant: "xs",
        className: "inline-block px-2 py-1 font-medium bg-red-50 text-red-800 rounded"
    }, "Ausgebucht") : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "sm",
        className: "text-green-800 font-medium"
    }, availableSlots, " ", availableSlots === 1 ? 'Platz' : "Pl\xe4tze", " frei")))));
}

},{"react":"lbBKc","./Text":"ilUQ0","./Card":"6QY7C","./Icon":"62fBo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gE3fK":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OnboardingBanner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
const STORAGE_KEY = 'eggsconnect-onboarding-dismissed';
function OnboardingBanner({ className = '' }) {
    const [visible, setVisible] = (0, _react.useState)(()=>{
        try {
            return localStorage.getItem(STORAGE_KEY) !== 'true';
        } catch (e) {
            return true;
        }
    });
    const [dismissing, setDismissing] = (0, _react.useState)(false);
    if (!visible) return null;
    const handleDismiss = ()=>{
        try {
            localStorage.setItem(STORAGE_KEY, 'true');
        } catch (e) {
        /* ignore — banner will reappear next visit */ }
        setDismissing(true);
        setTimeout(()=>setVisible(false), 300);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `relative bg-eggs-yellow rounded-xl p-4 mb-6 animate-fade-in transition-opacity duration-300 ${dismissing ? 'opacity-0' : 'opacity-100'} ${className}`,
        role: "region",
        "aria-label": "Onboarding"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: handleDismiss,
        className: "absolute top-2 right-2 w-12 h-12 flex items-center justify-center rounded-full hover:bg-black/10 transition-all duration-200",
        "aria-label": "Schlie\xDFen"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true",
        className: "text-xl leading-none"
    }, "\u2715")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Heading",
        variant: "h3",
        className: "pr-10 mb-2"
    }, "30 Minuten. Ein Experte. Dein Thema."), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "Body",
        variant: "Base"
    }, "Steig in eine Umadum-Gondel und triff einen Experten f\xFCr ein pers\xF6nliches Gespr\xE4ch zu deinem Thema."));
}

},{"react":"lbBKc","./Text":"ilUQ0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aXsXZ":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SmartPicture);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dynamicMedia = require("../utils/dynamicMedia");
function SmartPicture({ image, smartCrops, preferredCrop, fallback, alt = '', className = '' }) {
    var _resolved_sources;
    const resolved = (0, _dynamicMedia.getImageUrl)(image, smartCrops, preferredCrop);
    if (!resolved && !fallback) return null;
    if (!resolved) return /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: fallback,
        alt: alt,
        className: className
    });
    if ((_resolved_sources = resolved.sources) === null || _resolved_sources === void 0 ? void 0 : _resolved_sources.length) return /*#__PURE__*/ (0, _reactDefault.default).createElement("picture", null, resolved.sources.map((s)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("source", {
            key: s.media,
            media: s.media,
            srcSet: s.srcSet
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: resolved.src,
        alt: alt,
        className: className
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: resolved.src,
        alt: alt,
        className: className
    });
}

},{"react":"lbBKc","../utils/dynamicMedia":"2jTmA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3FKx2":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QRCode);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _qrcodeReact = require("qrcode.react");
function QRCode({ value, size = 200, className = '' }) {
    if (!value) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _qrcodeReact.QRCodeSVG), {
        value: value,
        size: size,
        level: "H",
        includeMargin: true
    }));
}

},{"react":"lbBKc","qrcode.react":"cW92x","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cW92x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QRCodeCanvas", ()=>QRCodeCanvas);
parcelHelpers.export(exports, "QRCodeSVG", ()=>QRCodeSVG);
// src/index.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var ERROR_LEVEL_MAP = {
    L: qrcodegen_default.QrCode.Ecc.LOW,
    M: qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var DEFAULT_MINVERSION = 1;
var SPEC_MARGIN_SIZE = 4;
var DEFAULT_MARGIN_SIZE = 0;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x,
        y,
        h,
        w,
        excavation,
        opacity,
        crossOrigin
    };
}
function getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? SPEC_MARGIN_SIZE : DEFAULT_MARGIN_SIZE;
}
function useQRCode({ value, level, minVersion, includeMargin, marginSize, imageSettings, size, boostLevel }) {
    let qrcode = (0, _reactDefault.default).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return qrcodegen_default.QrCode.encodeSegments(segments, ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells, margin, numCells, calculatedImageSettings } = (0, _reactDefault.default).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode,
        margin,
        cells,
        numCells,
        calculatedImageSettings
    };
}
var SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var QRCodeCanvas = (0, _reactDefault.default).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value, size = DEFAULT_SIZE, level = DEFAULT_LEVEL, bgColor = DEFAULT_BGCOLOR, fgColor = DEFAULT_FGCOLOR, includeMargin = DEFAULT_INCLUDEMARGIN, minVersion = DEFAULT_MINVERSION, boostLevel, marginSize, imageSettings } = _a, extraProps = __objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style } = _b, otherProps = __objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, _reactDefault.default).useRef(null);
    const _image = (0, _reactDefault.default).useRef(null);
    const setCanvasRef = (0, _reactDefault.default).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, _reactDefault.default).useState(false);
    const { margin, cells, numCells, calculatedImageSettings } = useQRCode({
        value,
        level,
        minVersion,
        boostLevel,
        includeMargin,
        marginSize,
        imageSettings,
        size
    });
    (0, _reactDefault.default).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if (SUPPORTS_PATH2D) ctx.fill(new Path2D(generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, _reactDefault.default).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = __spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, _reactDefault.default).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /* @__PURE__ */ (0, _reactDefault.default).createElement("canvas", __spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
QRCodeCanvas.displayName = "QRCodeCanvas";
var QRCodeSVG = (0, _reactDefault.default).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value, size = DEFAULT_SIZE, level = DEFAULT_LEVEL, bgColor = DEFAULT_BGCOLOR, fgColor = DEFAULT_FGCOLOR, includeMargin = DEFAULT_INCLUDEMARGIN, minVersion = DEFAULT_MINVERSION, boostLevel, title, marginSize, imageSettings } = _a, otherProps = __objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin, cells, numCells, calculatedImageSettings } = useQRCode({
        value,
        level,
        minVersion,
        boostLevel,
        includeMargin,
        marginSize,
        imageSettings,
        size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, _reactDefault.default).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("svg", __spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, _reactDefault.default).createElement("title", null, title), /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
QRCodeSVG.displayName = "QRCodeSVG";

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2nLze":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StatusBadge);
parcelHelpers.export(exports, "STATUS_MAP", ()=>STATUS_MAP);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function StatusBadge({ status, label, sublabel, className = '' }) {
    const config = STATUS_MAP[status] || STATUS_MAP.open;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `flex flex-col items-center justify-center w-[72px] h-[72px] rounded-xl text-center ${config.colors} ${className}`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-xs font-medium leading-tight"
    }, label || config.label), sublabel && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "text-[10px] leading-tight mt-0.5 w-full px-1 opacity-75 line-clamp-2"
    }, sublabel));
}
const STATUS_MAP = {
    open: {
        label: 'Offen',
        colors: 'bg-green-100 text-green-800'
    },
    confirmed: {
        label: 'Vergeben',
        colors: 'bg-yellow-100 text-yellow-800'
    },
    'checked-in': {
        label: 'Eingecheckt',
        colors: 'bg-blue-100 text-blue-800'
    },
    released: {
        label: 'Freigegeben',
        colors: 'bg-gray-100 text-gray-800'
    }
};

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}]},[], null, "parcelRequire33b7", {}, "./", "/")

//# sourceMappingURL=Privacy.cdb1d8f8.js.map
